<div *ngIf="!IsDisplayPrice && !IsSectorProductComparison &&
  !IsGetTotalCost && !IsMakeSectorsOrder && !IsHowToCutSticks">
  <div class="row">
    <div class="col-md-9">
      <h5 class="num" *ngIf="!categoriesLoading && AllSubCategory && AllSubCategory.length > 0">{{ 'NumberOfAddedItems'|translate }} : {{ Classes.length }}</h5>
    </div>
    <div class="col-md-3 divAddButton">
      <button class="Addbtn m-l-sm btn-icon-group" [matMenuTriggerFor]="menu" *ngIf="sectors && sectors.length > 1">
        <mat-icon class="icon-15 btn-icon">keyboard_arrow_down</mat-icon>
        {{ 'Sector' | translate }} {{ SectorName }}
      </button>
      <mat-menu #menu="matMenu" class="cardWithShadow">
        <button mat-menu-item *ngFor="let sector of sectors" (click)="changeSector(sector.key)">
          {{ sector.value }}
        </button>
      </mat-menu>
      <button class="Addbtn btn-icon-group" (click)="addNewDiv()">
        <i-tabler name="plus" class="icon-15 btn-icon"></i-tabler>
        {{ 'AddItem'|translate }}
      </button>
    </div>
  </div>
  <h5 class="text-center" *ngIf="!categoriesLoading && (!AllSubCategory || AllSubCategory.length == 0)">
    {{'NoProductsForSector' | translate}}
  </h5>
  <ng-container *ngIf="!categoriesLoading && AllSubCategory && AllSubCategory.length > 0">
    <form [formGroup]="ParentForm">
      <app-cost-calculation-form [ClassIndex]="i+1" [Classes]="Classes" [AllCostCalcAddsNames]="AllCostCalcAddsNames"
                                 (ParentForm)="GetParentForm($event)" [childForm]="ParentForm" [ColorList]="ColorList"
                                 [AllSubCategory]="AllSubCategory"
                                 *ngFor="let cls of Classes; let i = index" data-index="i">
      </app-cost-calculation-form>
    </form>

    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
      <mat-card-content class="mat-mdc-card-content text-center">
        <div class="d-md-flex">
          <button class="btn colorbtn " *ngIf="DisplayAllBtn" (click)="HowToCutSticks(ParentForm)">
            {{ 'HowToCutSticks'|translate }}
          </button>

          <button class="btn orangecolorbtn " *ngIf="DisplayAllBtn" (click)="MakeSectorsOrder(ParentForm)">
            {{ 'MakeSectorsOrder'|translate }}
          </button>

          <button class="btn colorbtn " *ngIf="DisplayAllBtn" (click)="CostCalculation(ParentForm)">
            {{ 'Cost-Calculation'|translate }}
          </button>

          <button class="btn orangecolorbtn " *ngIf="DisplayAllBtn"
                  (click)="SectorProductComparison(ParentForm)">
            {{ 'SectorComparison'|translate }}
          </button>

          <button class="btn colorbtn " *ngIf="DisplayAllBtn||DisplayOnlyPriceForClientBtn"
                  (click)="DisplayPriceForClient(ParentForm)">
            {{ 'DisplayPriceForClient'|translate }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>

<div *ngIf="IsHowToCutSticks">
  <app-how-to-cut-sticks [TotalCostInputData]="HowToCutSticksData" [SectorId]="sectorId"
                         (IsHowToCutSticks)="CheckIsHowToCutSticks($event)"></app-how-to-cut-sticks>
</div>

<div *ngIf="IsMakeSectorsOrder">
  <app-make-sectors-order [SectorsOrderData]="SectorsOrderData" [SectorId]="sectorId"
                          (IsMakeSectorsOrder)="CheckIsMakeSectorsOrder($event)"></app-make-sectors-order>
</div>

<div *ngIf="IsGetTotalCost">
  <app-cost-calculation [TotalCostInputData]="TotalCostData" [SectorId]="sectorId"
                        (IsGetTotalCost)="CheckIfIsTotalCost($event)">
  </app-cost-calculation>
</div>

<div *ngIf="IsSectorProductComparison">
  <app-sector-product-comparison [Product]="SectorProductData"
                                 (IsSectorProductComparison)="CheckIsSectorProductComparison($event)">
  </app-sector-product-comparison>
</div>

<div *ngIf="IsDisplayPrice">
  <app-display-price-for-client [DisplayPriceData]="DisplayPriceData" [SectorId]="sectorId"
                                (IsDisplayPrice)="CheckIsDisplayPrice($event)">
  </app-display-price-for-client>
</div>
